var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFikSmartLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 799.5 444.6",
    style: {
      enableBackground: "new 0 0 799.5 444.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#2B9BC6;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M397.3,229.3h-67.7c-7,0-12.7-5.5-12.7-12.2V2.1h68.5c6.6,0,11.9,5.1,11.9,11.4L397.3,229.3L397.3,229.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M689,104.4c-4.6,4.5-4.6,11.6,0,16l110.1,106.6v2.2c-141.8-2.2-83.1,19.8-183.3-79.7 c-3.3-6.4-58.3-2.1-64.3-3.2c-6.6,0-11.9,5.1-11.9,11.4v60.1c0,6.3-5.3,11.4-11.9,11.4h-52.3c-6.6,0-11.9-5.1-11.9-11.4V13.5 c0-6.3,5.3-11.4,11.9-11.4h52.3c6.6,0,11.9,5.1,11.9,11.4v58.6c0,6.3,5.3,11.4,11.9,11.4c6.2-1.2,60.2,3.1,63.7-3.2 c2.9-1,101.4-83.3,103.5-78.2c0,0,73.6,0,73.6,0v2.2L689,104.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M250.6,2.1v60.3H84.9c-12.4-0.6-9.6,13.2-9.6,21.4h175.3v59.5H87.9c-7,0-12.7,5.4-12.8,12.1l-0.9,73.7H1.2 C1.7-72.1-33.8,15.5,250.6,2.1L250.6,2.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "704.6,438.8 702.6,438.8 702.6,286.3 793.5,286.3 793.5,288.4 704.6,288.4  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "715.3,438.8 713.3,438.8 713.3,296.3 793.5,296.3 793.5,298.3 715.3,298.3  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "727,438.8 724.9,438.8 724.9,306.9 793.5,306.9 793.5,309 727,309  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "737.9,438.8 735.9,438.8 735.9,316.3 793.5,316.3 793.5,318.4 737.9,318.4  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 642,
    y: 286.3,
    className: "st0",
    width: 56.1,
    height: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 642,
    y: 296.4,
    className: "st0",
    width: 56.1,
    height: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 641.9,
    y: 306.4,
    className: "st0",
    width: 56.1,
    height: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 642,
    y: 316.3,
    className: "st0",
    width: 56.1,
    height: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 634.6,
    y: 283.7,
    className: "st0",
    width: 7.4,
    height: 7.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M642.4,291.3h-8.1v-8h8.1V291.3z M635,290.6h6.7V284H635V290.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 634.6,
    y: 293.8,
    className: "st0",
    width: 7.4,
    height: 7.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M642.4,301.4h-8.1v-8h8.1V301.4z M635,300.7h6.7v-6.6H635V300.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 634.6,
    y: 313.7,
    className: "st0",
    width: 7.4,
    height: 7.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M642.4,321.3h-8.1v-8h8.1V321.3z M635,320.7h6.7v-6.6H635V320.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 634.6,
    y: 303.4,
    className: "st0",
    width: 7.4,
    height: 7.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M642.4,311.1h-8.1v-8h8.1V311.1z M635,310.4h6.7v-6.6H635V310.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 791.7,
    y: 283.7,
    className: "st0",
    width: 7.4,
    height: 7.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M799.5,291.3h-8.1v-8h8.1V291.3z M792.1,290.6h6.7V284h-6.7V290.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 791.7,
    y: 293.8,
    className: "st0",
    width: 7.4,
    height: 7.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M799.5,301.4h-8.1v-8h8.1V301.4z M792.1,300.7h6.7v-6.6h-6.7V300.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 791.6,
    y: 303.7,
    className: "st0",
    width: 7.4,
    height: 7.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M799.3,311.4h-8.1v-8h8.1V311.4z M791.9,310.7h6.7v-6.6h-6.7V310.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 791.7,
    y: 313.7,
    className: "st0",
    width: 7.4,
    height: 7.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M799.5,321.3h-8.1v-8h8.1V321.3z M792.1,320.7h6.7v-6.6h-6.7V320.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 733.2,
    y: 435.2,
    className: "st0",
    width: 7.4,
    height: 7.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M741,442.8h-8.1v-8h8.1V442.8z M733.5,442.2h6.7v-6.6h-6.7V442.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 722.2,
    y: 435.2,
    className: "st0",
    width: 7.4,
    height: 7.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M730,442.8h-8.1v-8h8.1V442.8z M722.6,442.2h6.7v-6.6h-6.7V442.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 711.1,
    y: 435.1,
    className: "st0",
    width: 7.4,
    height: 7.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M718.8,442.8h-8.1v-8h8.1V442.8z M711.4,442.1h6.7v-6.6h-6.7V442.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 699.9,
    y: 435.1,
    className: "st0",
    width: 7.4,
    height: 7.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M707.7,442.8h-8.1v-8h8.1V442.8z M700.2,442.1h6.7v-6.6h-6.7V442.1z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.7,405.5c9.5,4.9,24.8,9.8,40.3,9.8c16.7,0,25.5-6.8,25.5-17.1c0-9.8-7.6-15.5-26.9-22 c-26.7-9.4-44.4-23.9-44.4-46.9C3.2,302.4,26.3,282,64,282c18.4,0,31.5,3.5,41,8l-8.1,28.6c-6.2-3-17.9-7.5-33.4-7.5 c-15.7,0-23.4,7.3-23.4,15.2c0,10.1,8.8,14.5,29.8,22.3c28.4,10.3,41.5,24.8,41.5,47.1c0,26.5-20.5,49-64.6,49 c-18.4,0-36.5-4.9-45.5-9.8L8.7,405.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M272.1,381.8c-0.7-19-1.4-41.9-1.4-64.9h-0.5c-5.2,20.2-11.9,42.6-18.1,61.1l-19.6,61.6h-28.4L187,378.7 c-5.2-18.7-10.5-41.2-14.5-61.9H172c-0.7,21.3-1.7,45.7-2.6,65.4l-3.1,60h-33.6l10.3-157.9h48.4L207,337 c5.2,18.3,10,38,13.6,56.5h1c4.3-18.3,9.8-39.1,15.3-56.7l16.9-52.5h47.7l8.6,157.9h-35.3L272.1,381.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M374.7,401.7l-11.4,40.5h-37.4l48.9-157.9h47.7l50.1,157.9h-39.3l-12.4-40.5H374.7z M415.5,375l-10-33.5 c-2.9-9.4-5.7-21.1-8.1-30.5h-0.5c-2.4,9.4-4.8,21.3-7.4,30.5l-9.5,33.5H415.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M493.7,286.4c11.7-1.9,28.9-3.3,48.4-3.3c23.8,0,40.5,3.5,52,12.4c9.8,7.5,15,18.7,15,33.3 c0,19.9-14.5,33.7-28.4,38.7v0.7c11.2,4.5,17.4,14.8,21.5,29.3c5,18,9.8,38.7,12.9,44.8h-37.2c-2.4-4.7-6.4-17.3-11-36.8 c-4.5-19.9-11.4-25.1-26.5-25.3h-10.7v62.1h-36V286.4z M529.7,354.4H544c18.1,0,28.9-8.9,28.9-22.7c0-14.3-10-21.8-26.7-21.8 c-8.8,0-13.8,0.5-16.5,1.2V354.4z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFikSmartLogo);
export default __webpack_public_path__ + "static/media/FikSmartLogo.ac2059fa451e76bb75e36e8a581819cf.svg";
export { ForwardRef as ReactComponent };